import { useCreate } from '../../../../../../api';
import { useTranslate } from '../../../../../../hooks';

export function useCancelSwap() {
  const { translate } = useTranslate();

  const { mutateAsync, isLoading } = useCreate({
    url: 'shift-management/employees/shift-patterns/assigned/swap/cancel',
    customInvalidateQueriesUrl: 'shift-management/shift-rosters',
    msg: `${translate('Swap shift cancelled successfully!')}`,
  });

  return {
    isLoading,
    cancelSwap: mutateAsync,
  };
}
